module.exports = __webpack_public_path__ + "static/scale-model-of-mayfield-park-and-nature-preserve-in-austin-texas-ef7978510987c9c6c3ad36cf947941b9.png";